module.exports = __webpack_public_path__ + "static/logo-f079559f248d11f7bd056799b4d9c918.svg";